import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "bf-course-card" }
const _hoisted_2 = {
  key: 0,
  class: "bf-course-card__info"
}
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("b", null, "Kursbeschreibung", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { class: "bf-course-card__time" }
const _hoisted_8 = {
  key: 1,
  class: "bf-course-card__location"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("–")
const _hoisted_11 = {
  key: 2,
  class: "bf-course-card__prerequisite"
}
const _hoisted_12 = { class: "bf-course-card__actions" }
const _hoisted_13 = {
  key: 0,
  class: ""
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spin fa-spinner" }, null, -1)
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Popper = _resolveComponent("Popper")!
  const _component_CourseActions = _resolveComponent("CourseActions")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "bf-course-card__type",
      style: _normalizeStyle('color:#'+_ctx.course.color)
    }, _toDisplayString(_ctx.course.course_type.name), 5),
    (_ctx.description)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_Popper, {
            hover: true,
            arrow: true
          }, {
            content: _withCtx(() => [
              _createElementVNode("span", null, [
                _hoisted_4,
                _hoisted_5,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.descriptionLines, (line) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: line }, [
                    _createElementVNode("span", null, _toDisplayString(line), 1),
                    _hoisted_6
                  ], 64))
                }), 128))
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("i", {
                class: "fa fa-info-circle",
                "aria-label": 'Kursbeschreibung: ' + _ctx.description
              }, null, 8, _hoisted_3)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.formatTime(_ctx.course.start_hours, _ctx.course.start_minutes)) + " - " + _toDisplayString(_ctx.formatTime(_ctx.course.end_hours, _ctx.course.end_minutes)), 1),
    (_ctx.course.location?.name)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createTextVNode(_toDisplayString(_ctx.course.location?.name) + " ", 1),
          (_ctx.course.info_bringalong)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_9,
                _hoisted_10
              ], 64))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.course.info_bringalong)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.course.info_bringalong), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_12, [
      (_ctx.loadingEnrollments)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
        : _createCommentVNode("", true),
      _withDirectives(_createVNode(_component_CourseActions, {
        course: _ctx.course,
        "user-course-enrollments": _ctx.userCourseEnrollments,
        onEnrollmentStatusChange: _ctx.onEnrollmentStatusChange
      }, null, 8, ["course", "user-course-enrollments", "onEnrollmentStatusChange"]), [
        [_vShow, !_ctx.loadingEnrollments]
      ])
    ])
  ]))
}